export function log(message, extra = {}, level = 'error') {
    const logger = typeof console[level] === 'function' ? console[level] : console.error;
    logger(message, extra);
}
